import React, { useEffect, useState } from 'react'
import '../styles/program.scss'



export default function Region({  allOrganizers, setOrgPerRegion, regarr, setRegarr, menuClickHandler, showItem }) {
  
    const [isOpen, setIsOpen] = useState(false);
   
    let arr = [];

    allOrganizers.filter((i) => arr.push(i.region))
 
    function toFindDuplicates(arr) {
        const uniqueElements = new Set(arr);
        // const filteredElements =
        arr.filter((item) => {
            if (uniqueElements.has(item)) {
                // uniqueElements.delete(item);
            } else {
                return item;
            }
        });

        return [...new Set(uniqueElements)];
    }

    const regions = toFindDuplicates(arr);
    

    function handleRegionArrrow() {
        setIsOpen((current) => !current);
    }

 
    function handleCheck(item) {
        
       
        if (regarr.includes(item)) {

            setRegarr(regarr.filter(r => { return r !== item }))
           
        }
        else setRegarr([...regarr, item])

       

    }

    useEffect(() => {
      regarr && setOrgPerRegion([...regarr])
    }, [])

   

    localStorage.setItem('reg_arr', regarr)
    

    return (
        
        <div className=" dropdownContainer">
                   
            <div className="chooseRegion" style={{
                borderBottomLeftRadius: isOpen ? '0px' : '8px',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                borderBottomRightRadius: isOpen ? '0px' : '8px',
            }}>
                            <div
                                style={{
                                    position: "relative",

                                    boxSizing: "border-box",
                                 
                                }}
                >
                    <p className='dropdownTitle' >{regarr && regarr?.length === 1 ? regarr[0] : regarr?.length > 0 ? 'Valgte regioner' : 'Alle Regioner'}</p>
                        {regarr?.length > 0 && regarr?.length && < span className="one">{regarr.length}</span>  }
                               
                        <button className='chooseBtn'
                        onClick={() => { handleRegionArrrow(); menuClickHandler('region') }}
                                   
                                >
                        <p className={showItem === "region" ? "rotate down" : "rotate "}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
                                    <path d="M1.5 1L10 10L18.5 1" stroke="white" stroke-width="2" stroke-linecap="round" />
                                </svg>
                                    </p>
                                </button>
                            </div>
                {showItem === 'region' && (
                    <div className={`scroll  ${showItem === "region" ? 'dropdown_show' : null}`}
                                   
                        >
                        {regions && regions.sort((a, b) => a > b ? 1 : -1).map((item,index) => (
                                <div key={index } style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    height: "44px", marginBottom: '4px',
                                    padding: "10px 10px 10px 16px", width: '98%', borderRadius: '6px',
                                    backgroundColor:regarr.length && regarr.includes(item) ? '#3E455C' : ''
                                }} onClick={()=> handleCheck(item)}>
                                <p className='dropdowns-lists'>{item}</p>
                                {/*<input type='checkbox' checked={regarr.length && regarr.includes(item) ? true: false} />*/}
                                        {regarr.length && regarr.includes(item) ?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                            <path d="M7 11L11 16L17.5 7" stroke="white" stroke-width="2" stroke-linecap="round" />
                                        </svg>
                                        :
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                        </svg>}
                                   
                                </div>
                            ))
                            }
                           
                                </div>
                            )}
                        </div>
                   
                    
                </div>
               

           
        )
}